import type { GovPaginationProps } from '@gov-design-system-ce/react/gov-pagination';
import { GovPagination } from '@gov-design-system-ce/react/gov-pagination';
import { useBreakpoints } from '@gov-nx/utils/web/hooks/useBreakpoints';

export const Pagination = ({ onPage, ...props }: GovPaginationProps) => {
	const { isSm } = useBreakpoints();

	return (
		<GovPagination
			{...props}
			onPage={onPage}
			type={isSm ? 'select' : props.type}
		/>
	);
};
